import React from 'react';
import '../App.css';

function Contact() {
    return (
        <section id="contact">
            <h2>Contact</h2>
            <p>Email: your.email@example.com</p>
        </section>
    );
}

export default Contact;
